import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=07d953f3&"
import script from "./PostFeed.vue?vue&type=script&lang=js&"
export * from "./PostFeed.vue?vue&type=script&lang=js&"
import style0 from "./PostFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports